import { Reveal, Eyebrow } from "@/components/Reveal";
import Marquee from "@/components/Marquee";
import { LENDERS, NETWORK_STATS } from "@/data/content";

export default function LenderNetwork() {
  return (
    <section data-testid="lender-network" className="relative bg-obsidian text-white py-20 sm:py-28 grain overflow-hidden">
      <div className="absolute top-0 left-1/3 w-[30rem] h-[30rem] rounded-full bg-gold/10 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <Reveal>
          <Eyebrow dark>The network behind us</Eyebrow>
          <div className="grid lg:grid-cols-2 gap-10 items-end mb-16">
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.1]">
              One broker. <span className="font-editorial italic font-medium text-gold">Australia's largest</span> broker community.
            </h2>
            <p className="text-white/55 leading-relaxed max-w-lg lg:justify-self-end">
              Invesmo is an authorised credit representative of LMG Broker Services — the aggregation group behind
              more than 6,000 brokers nationwide. That scale means sharper pricing, broader policy knowledge and
              access to over 100 lenders on a single panel.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-3xl overflow-hidden mb-16">
          {NETWORK_STATS.map((s, i) => (
            <Reveal key={s.label} delay={0.08 * i}>
              <div className="bg-obsidian px-6 py-10 h-full" data-testid={`network-stat-${i}`}>
                <div className="font-display text-3xl sm:text-4xl font-bold text-gold">{s.value}</div>
                <div className="text-xs sm:text-sm text-white/50 mt-2 leading-snug">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Marquee items={LENDERS} dark slow testid="lender-marquee" />
      <p className="text-center text-[11px] text-white/30 mt-4 px-6">
        Panel membership varies by lender and product. Lenders shown are part of the LMG Broker Services aggregation panel.
      </p>
    </section>
  );
}
